import React from 'react';
import { Layout } from 'antd';
import './footer.scoped.scss';

export function Footer() {
  const { Footer } = Layout;

  return (
    <Footer style={{ textAlign: 'center', backgroundColor: '#000', padding: '1rem 0', color: '#eee' }}>
      <div style={{ marginBottom: '1rem' }}>LeanApp - İSG Portalı (v.a.1) © 2021</div>
    </Footer>
  );
}
